export default {
  HR: "Recurso humano",
  SUPPLIES: "Recurso material",
  EQUIPMENT: "Equipo",
  OPERATIVE_EXPENSES: "Gasto operativo",
  ADMINISTRATIVE_EXPENSES: "Gasto Administrativo",
  ADAPTATION_OR_EQUIPMENT: "Adecuación y/o equipamiento"
};
